export interface Meeting {
  id: number,
  subject: string,
  virtual: boolean,
  location: string,
  created_at: Date,
  status: MeetingStatus,
  picked_moment?: MeetingMoment,
  invitees: Invitee[],
  avatar_url?: string,
  owner_firstName: string,
  owner_lastName: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  'page-fields'?: any,
  isOwner: boolean,
  owner_has_to_accept: boolean,
  receiver: number,
  page_id: number,
}

export interface MeetingMoment {
  start: Date,
  end: Date,
}

export interface Invitee {
  id: number,
  email: string,
  avatar_url: string,
  first_name: string,
  last_name: string,
  status: MeetingStatus,
}

export interface Availability {
  selected?: boolean,
  start: Date,
  end: Date,
}

export interface Company {
  id: number,
  employees: Employee[],
  name: string,
  avatar: string,
  not_saved?: boolean,
  pages: MeetingPage[],
  admin?: boolean,
}
export type Employee = {
  id: number,
  email: string,
  admin: boolean,
  confirmed: boolean,
  first_name: string,
  last_name: string,
  function: string,
  phone_number: string,
  required: boolean,
  avatar: string,
}

export type Range = {
  days: number[],
  from: number,
  to: number,
}

export interface Calendar {
  name: string,
  calendar_id: string,
  email: string,
  agendas: Agenda[],
}
export interface Agenda {
  id: string,
  name: string,
  agenda_name: string,
}

export enum MeetingStatus {
  DECLINED = 'declined',
  CONFIRMED = 'confirmed',
}

export enum Tiers {
  PLUS = 'plus',
  PROFESSIONAL = 'professional',
  FREE = 'free',
}

export enum Subscription {
  PLUS = 'plus',
  PROFESSIONAL = 'professional',
  PROFESSIONAL_YEARLY = 'professional-yearly',
}

export interface Integration {
  integration_id: number,
  logo: string,
  name: string,
  connected?: boolean,
  auth_url: string,
  actions: IntegrationActions,
}

export interface IntegrationActions {
  onRequest: IntegrationAction[],
  onSchedule: IntegrationAction[],
}

export interface IntegrationAction {
  action_id: number,
}

export type Duration = {
  label: string,
  duration: number,
};

export type MeetingPage = {
  id: number,
  name: string,
  new?: boolean,
  avatar: string,
  logo: string,
  employees: Employee[],
  preferred_times: Range[],
  meetingWithOne: boolean,
  pixel: string,
  ga: string,
  css: string,
  js: string,
  colors: MeetingPageColors,
  copy: MeetingPageCopy,
  display_name: string,
  auto_accept: boolean,
  one_moment: boolean,
  seq: boolean,
  buffer: boolean,
  start?: string,
  end?: string,
  fastest_possible: boolean,
  ignore_calendars: boolean,
  integrations: Integration[],
  location: Location,
  timezone: string,
  fields: MeetingPageField[],
  not_saved?: boolean,
  participants: number,
};

export type MeetingPageCopy = {
  tag_line?: string,
  page_name: string,
  button: string,
  page_outro?: string,
}

export type MeetingPageColors = {
  primary: string,
  secondary: string,
}

export type Location = {
  my_office?: {
    enabled: boolean,
    locations: string[],
  },
  call?: {
    enabled: boolean,
    options: [
      {
        type: string,
        value: string,
      }
    ],
  },
  their_office?: {
    enabled: boolean,
  },
}

export type MeetingPageField = {
  id: number,
  label: string,
  required: boolean,
  type: MeetingPageFieldType,
  value: string | number,
  duration?: number,
  placeholder?: string,
  copy?: {
    physical?: string,
    videocall?: string,
  },
  hasLocation?: boolean,
  hasVirtual?: boolean,
  selected?: string,
  durations?: Duration[],
};

export enum MeetingPageFieldType {
  EMAIL = 'email',
  NAME = 'name',
  DURATION = 'duration',
  TEXT = 'text',
  LOCATION = 'location',
  RADIO = 'radio',
  NUMBER = 'number',
  SELECT = 'select',
}

export interface ApiResponse {
  success: boolean,

  meeting_id?: number,
  user_key?: string,
  user_id?: number,

  url?: string,

  reason?: string,

  id?: string,
  token?: string,
  agendas?: Agenda[],
  agenda_application?: string,
  agenda_email?: string,

  error?: string,
}
